import { useCallback, useState, useEffect } from "react";
import Image from 'next/image'
import styles from "./proprietyGalery.module.css";
import Slider from "react-slick";
import useModal from "hooks/useModal";
import dynamic from "next/dynamic";


const ImageModal = dynamic(() => import("components/ImageModal"), {
  ssr: false
})

export default function ProprietyGalery({ data }) {
  const [ambienteButton, setAmbienteButton] = useState("");
  const [galeria, setGaleria] = useState([]);
  const [selectedImg, setSelectedImg] = useState("");
  const { isShowing, toggle } = useModal();

  const handleImg = useCallback((img) => {
    setSelectedImg(img);
    toggle();
  }, []);

  useEffect(() => {
    let lista = [];
    if (ambienteButton === "") {
      data &&
      data?.map((item) => {
        item.imagens.map((img) => {
          lista.push(img);
        });
      });
      setGaleria(lista);
    } else {
      data &&
      data?.map((item) => {
        if (item.ambiente === ambienteButton) {
          item.imagens.map((img) => {
            lista.push(img);
          });
        }
      });
      setGaleria(lista);
    }
  }, [ambienteButton]);

  const settings = {
    className: "galeryCarousel",
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    rows: galeria.length >= 10 ? 2 : 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          rows: 1,
        },
      },
    ],
  };

  return (
    <section className={styles.container}>
      <div className="container-full justify-content-center">
        <div className={`grid-cont flex-column ${styles.galeryHeader}`}>
          <div className={styles.title}>
            <div className={styles.parallelogramDetail} />
            <span>
              <strong>Galeria</strong> de imagens
            </span>
          </div>
          <div className={styles.buttons}>
            {data &&
              data.map((item) => {
                return (
                  <button
                    className={
                      ambienteButton === item.ambiente ? styles.activeBtn : ""
                    }
                    key={item.id}
                    onClick={() => setAmbienteButton(item.ambiente)}
                  >
                    {item.ambiente}
                  </button>
                );
              })}
          </div>
        </div>
      </div>
      <div className={`${styles.content}`}>
        <div className={styles.galery}>
          <Slider {...settings}>
            {galeria.map((item) => {
              return (
                <div
                  key={Math.random()}
                  onClick={() => handleImg(item.img.url)}
                  className={`${styles.galeryItem}`}
                >
                  <Image 
                        src={item.img.url}
                        width={381}
                        height={283}
                        layout="responsive"
                        objectFit="cover"
                      />
                  {/* <img src={item.img.url} width={381} height={283}/> */}
                  {item.legenda && item.legenda.length > 0 && (
                    <span>{item.legenda}</span>
                  )}
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
      <ImageModal isShowing={isShowing} hide={toggle} imagem={selectedImg} />
    </section>
  );
}
